/**
 * Easing function for transitions.
 * Takes value 0-1 and outputs eased value 0-1.
 */
export function easeInOutQuadratic(input: number) {
    return input < 0.5 ? 2 * input * input : -1 + (4 - 2 * input) * input
}
